export default "__VITE_ASSET__RQ5c8gcc__"